import { useState, useEffect, useCallback } from "react";
import strings from "../../../locales/ro.json";
import { useApi } from "../../../hooks/useApi";

export default function useContactingManager() {
  const [dangerUsers, setDangerUsers] = useState([]);
  const [derankUsers, setDerankUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { api, authToken } = useApi();

  const clearError = () => setError(null);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [dangerRes, derankRes] = await Promise.all([
        api("attendance/danger"),
        api("attendance/derank"),
      ]);

      if (Array.isArray(dangerRes)) setDangerUsers(dangerRes);
      if (Array.isArray(derankRes)) setDerankUsers(derankRes);
    } catch (err) {
      console.error("Error fetching contacting data:", err);
      setError(strings.admin.contacting.errors.fetch);
    } finally {
      setLoading(false);
    }
  }, [api]);

  useEffect(() => {
    if (authToken) fetchAll();
  }, [authToken, fetchAll]);

  /**
   * Build recipients array from selected user IDs and user list.
   * Filters out users without a phone number.
   */
  const buildRecipients = useCallback((selectedIds, userList) => {
    return userList
      .filter((u) => selectedIds.has(u.id) && u.phone)
      .map((u) => ({ phone: u.phone, name: u.name }));
  }, []);

  /**
   * Get users that were selected but have no phone number.
   */
  const getMissingPhoneUsers = useCallback((selectedIds, userList) => {
    return userList.filter((u) => selectedIds.has(u.id) && !u.phone);
  }, []);

  return {
    dangerUsers,
    derankUsers,
    loading,
    error,
    clearError,
    fetchAll,
    buildRecipients,
    getMissingPhoneUsers,
  };
}
